import { EmptyState } from '../components/ui';

export default function EventsSection() {
  return (
    <EmptyState
      title="Events pipeline"
      message="Manual entry. Each row: event name, revenue target, projected margin %, month, RAG status, owner. Use the form to add events, or POST /manual/event."
    />
  );
}
